






























import { Component } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
class PageUserloginattemptRequest extends PageRequest {
  FilterText: string;
}
class PageCompanyRequest{
  cId:Number;
}
@Component({
  components: { },
})
export default class Equipments extends AbpBase {
  pagerequest: PageUserloginattemptRequest = new PageUserloginattemptRequest();
  publicpagerequest: PageUserloginattemptRequest = new PageUserloginattemptRequest();
  pagecompanyrequest: PageCompanyRequest = new PageCompanyRequest();
  userName: string;
  cId:Number;
  get list() {
    return this.$store.state.auditlog.list;
  }
  get loading() {
    return this.$store.state.auditlog.loading;
  }
  pageChange(page: number) {
    this.$store.commit("auditlog/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("auditlog/setPageSize", pagesize);
    this.getpage();
  }

  getsearch(){
    this.$store.state.thequipment.currentPage=1;
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
      this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters
    await this.$store.dispatch({
      type: "auditlog/getPaged",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.auditlog.pageSize;
  }
  get totalCount() {
    return this.$store.state.auditlog.totalCount;
  }
  get currentPage() {
    return this.$store.state.auditlog.currentPage;
  }
  getuserName() {
    //console.log(this.$store.state.session.user);
    this.userName = this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
    return this.userName;
  }
  get company() {
    return this.$store.state.company.list;
  }
  companylist() {
    return this.$store.state.company.list;
  }
  columns = [
    {
      title: "所属公司",
      key: "cId",
      render: (h, params) => {
        let cId = params.row.cId;
        let clist = this.companylist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(cId==entry.id){
            cId=entry.cName;
            break;
          }
        }
        if(cId==0){
          cId="";
        }
        return h("span", cId);
      },
    },
    // {
    //   title: "用户名称或邮箱地址",
    //   key: "userNameOrEmailAddress",
    // },
    {
      title: "服务名称",
      key: "serviceName",
    },
    {
      title: "执行方法名称",
      key: "methodName",
    },
    {
      title: "调用参数",
      key: "parameters",
    },
    // {
    //   title: "返回值",
    //   key: "returnValue",
    // },
    {
      title: "方法开始执行时间",
      key: "executionTime",
    },
    {
      title: "方法总执行时长",
      key: "executionDuration",
    },
    {
      title: "客户端IP地址",
      key: "clientIpAddress",
    },
    // {
    //   title: "顾客名称",
    //   key: "clientName",
    // },
    {
      title: "浏览器信息",
        width: 240,
      key: "browserInfo",
    }
    // {
    //   title: "其他",
    //   key: "exception",
    // },
    // {
    //   title: "模拟用户ID",
    //   key: "impersonatorUserId",
    // },
    // {
    //   title: "模拟客户ID",
    //   key: "impersonatorTenantId",
    // }
    // {
    //   title: "自定义数据",
    //   key: "customData",
    // }
  ];
  
 
 created() {
    this.getuserName();
    if (this.userName !== "admin") {
      //不符合权限的，你就没有操作这个列名！！！
      this.columns = this.columns.filter((col) => col.title !== "所属公司");
    }

    this.getpage();
    
  }
}
